import { Button, Grid, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import SelectPublico from "../../../../../../../components/SelectsSimpleApiQuery/SelectPublico";
import SelectFazenda from "../../../../../../../components/SelectsSimpleApiQuery/SelectFazendas";
import SelectCategoria from "../../../../../../../components/SelectsSimpleApiQuery/SelectCategoria";
import SelectTipoDocReceber from "../../../../../../../components/SelectsSimpleApiQuery/SelectTipoDocReceber";

export default function Step01() {
  const { setValue, getValues, control, watch, handleSubmit } =
    useFormContext();
  const handleNext = getValues("funcoesAux.onNext");

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 7 }}>
        <Controller
          name="identificacao.publico_dado"
          control={control}
          rules={{ required: "Campo obrigatório" }}
          render={({ field, fieldState: { error, invalid } }) => {
            return (
              <SelectPublico
                {...field}
                error={invalid}
                required
                errorMessage={error?.message}
                value={field.value}
                onChange={(valor) => {
                  field.onChange(valor);
                  setValue("identificacao.fazenda_dado", null);
                }}
              />
            );
          }}
        />
      </Grid>
      <Grid size={{ xs: 5 }}>
        <Controller
          name="identificacao.fazenda_dado"
          control={control}
          render={({ field }) => {
            const publicoSelecionado = watch("identificacao.publico_dado");
            const isDisabled = !publicoSelecionado?.codigo_publico;

            return (
              <SelectFazenda
                {...field}
                disabled={isDisabled}
                value={field.value}
                codigo={publicoSelecionado?.codigo_publico}
                tipo={publicoSelecionado?.tipo_publico}
                onChange={(valor) => field.onChange(valor)}
              />
            );
          }}
        />
      </Grid>

      <Grid size={{ xs: 3 }}>
        <Controller
          name="identificacao.tipo_documento"
          control={control}
          rules={{ required: "Campo obrigatório" }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectTipoDocReceber
              {...field}
              required
              error={invalid}
              value={field.value}
              onChange={(valor) => {
                field.onChange(valor);
                setValue(
                  "identificacao.numero_documento",
                  valor?.sugestao_numero
                );
              }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <Controller
          name="identificacao.numero_documento"
          control={control}
          rules={{ required: "Campo obrigatório" }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              type="number"
              label="Número"
              required
              value={field.value}
              fullWidth
              onChange={(e) => field.onChange(e.target.value)}
              slotProps={{ inputLabel: { shrink: Boolean(field.value) } }}
              error={Boolean(error)}
              helperText={error ? "Campo obrigatório" : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 5 }}>
        <Controller
          name="identificacao.categoria"
          control={control}
          rules={{ required: "Campo obrigatório" }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectCategoria
              {...field}
              required
              error={invalid}
              value={field.value}
              onChange={(valor) => field.onChange(valor)}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(handleNext)}
        >
          Avançar
        </Button>
      </Grid>
    </Grid>
  );
}
